function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatronIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.634349,0,0,0.634349,12.5,12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "patron_icon.svg",
    transform: "matrix(1,0,0,1,-15,-15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.99447,0,0,4.94591,-21.643,-29.1147)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.446,
    y: 6.15,
    width: 1.056,
    height: 5.538,
    style: {
      fill: "rgb(255,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.49965,0,0,5.53757,-15.5647,-32.7536)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.314,
    cy: 8.019,
    r: 1.869,
    style: {
      fill: "rgb(255,0,0)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatronIconSm);
export default __webpack_public_path__ + "static/media/patron_icon_sm.10490570ba3b65a483123e7ff4ad3171.svg";
export { ForwardRef as ReactComponent };